/* @flow */
import React, { Fragment, PureComponent } from "react";
import Fieldset from "../Fieldset";
import AddButton from "../AddButton";
import Modal from "../Modal";
import { Portal } from "../Portal";
import { connect } from "react-redux";
import type { RootState, DDAEntry, Action, UIState } from "../../types";
import ErrorBlock from "../ErrorBlock";
import { AddEditDDAEntry } from "./AddEditDDAEntry";
import { ResolvedDDAForm } from "./ResolvedDDAForm";


type DDAState = {
  modalIsOpen: boolean,
  ddaIdForEdit: string | null
};

type DDAProps = {
  errorText?: string,
  values: DDAEntry,
  submitWasAttempted: boolean,
  dispatch: Action => Action,
  ui: UIState,
  DDAEligible: boolean
};

export class DDA extends PureComponent<DDAProps, DDAState> {
  state = {
    modalIsOpen: false,
    ddaIdForEdit: null
  };

  handleModalDismiss = () => {
    let shouldDismiss = true;

    if (this.props.ui.ddaIdForEdit) {
      // eslint-disable-next-line no-alert
      shouldDismiss = confirm("Unsaved changes. Are you sure?");
    }

    if (shouldDismiss) {
      this.setState({
        modalIsOpen: false
      });
    }
  };

  handleDDAAddClick = () => {
    this.setState({
      modalIsOpen: true,
      ddaIdForEdit: null
    });
  };

  handleModalDismissed = () => {
    this.props.dispatch({ type: "UI_DDA_EDIT_COMPLETE" });
  };

  handleDDAEditClick = (id: string) => {
      this.setState({
        modalIsOpen: true,
        ddaIdForEdit: id
      });
  };
  
   handleDDADeleteClick = (id: string) => {
      this.handleDDADelete(id);
  };


  handleDDAAdd = (dda_entry) => {
    this.setState({
      modalIsOpen: false
    });

    this.props.dispatch({
      type: "DDA_ADD",
      payload: dda_entry
    });
  };
  

  handleDDAUpdate = (dda_entry) => {   
    this.setState({
      modalIsOpen: false
    });
    
    this.props.dispatch({
      type: "DDA_UPDATE",
      payload: dda_entry
    });
  };
 
  handleDDADelete = (id: string) => {
    this.props.dispatch({
      type: "DDA_DELETE",
      payload: { id }
    });
  };

  renderDDA() {
    const { values } = this.props;

    if (values.id) {
      return (
        <ResolvedDDAForm
          dda_entry={values}
          onEditClick={this.handleDDAEditClick}
          onDeleteClick={this.handleDDADeleteClick}
        />
      );
    }
    
    return (
      <AddButton
        title="Click to review and sign the Direct Debit Agreement"
        onClick={this.handleDDAAddClick}
      />
    );
  }

  renderError() {
    const { errorText, submitWasAttempted } = this.props;
    const shouldRenderError = errorText !== undefined && submitWasAttempted;
    return shouldRenderError ? (
      <ErrorBlock message={errorText !== undefined ? errorText : ""} />
    ) : null;
  }

  render() {
    return (
      <Fragment>
        {this.props.noFieldset ? 
         (
        <>
          {this.renderError()}
          {this.renderDDA()}
        </>
      ) :
          <Fieldset>
            {this.renderError()}
            {this.renderDDA()}
          </Fieldset>
        }
        <Portal>
          <Modal
            allowDismissal={!this.props.ui.asyncActionInFlight}
            isOpen={this.state.modalIsOpen}
            onDismiss={this.handleModalDismiss}
            onDismissed={this.handleModalDismissed}
            testId="dda-modal">
            <AddEditDDAEntry
              seedDDAEntry={this.state.ddaIdForEdit ? this.props.values : null}
              commitDDAEntry={this.state.ddaIdForEdit ? this.handleDDAUpdate : this.handleDDAAdd}
              onClose={this.handleModalDismiss} 
            />       
          </Modal>
        </Portal>
      </Fragment>
    );
  }
}

const mapStateToProps = (state: RootState) => {  
  return {
    // Extract the values property from state.dda
    values: state.dda.values ? state.dda.values : {},
    errorText: state.dda.errorText,
    ui: state.ui || {},
    submitWasAttempted: state.lifecycle.submitWasAttempted,
  };
};
// $FlowFixMe
export default connect(mapStateToProps)(DDA);